import { LocalStorageService } from '../local-storage/local-storage.service';
import { useDispatch } from 'react-redux';
import { loginUser, logout as sessionLogout } from '../../features/login/session.slice';
import { ApiService } from '../api/api.service';
import { unwrapResult } from '@reduxjs/toolkit';
import { Config } from '../../config/config';

export const SESSION_KEY = 'vv-session';

export function useSessionService () {
  const dispatch = useDispatch();

  const init = () => {
    const _token = LocalStorageService.get({key: SESSION_KEY});
    ApiService.setAuth({token: _token});
  };

  const addDefaultErrorInterceptors = () => {
    ApiService.addErrorInterceptor({
      errorCode: 401, fn: () => {
        logout();
        window.location = Config.routePaths.main.vendor.path;
      }
    });
  };

  const login = ({username, password}) => {
    return dispatch(loginUser({username, password}))
      .then(unwrapResult)
      .then(data => {
        setToken(data.token);
        return data;
      });
  };

  const logout = () => {
    LocalStorageService.delete({key: SESSION_KEY});
    ApiService.cleanApi();
    dispatch(sessionLogout());
  };

  const setToken = (token) => {
    LocalStorageService.save({key: SESSION_KEY, value: token});
    ApiService.setAuth({token});
  };

  const isLoggedIn = () => {
    return !!LocalStorageService.get({key: SESSION_KEY});
  };

  return {logout, isLoggedIn, init, login, addDefaultErrorInterceptors, setToken};

}
